<template>
  <div>
    <div cols="12">
        <img class="mr-2" alt="" src="/static-appopensalud/img/icons/creditcard-grey.svg" height="30" width="30" />
        <h4 class="payment-title" v-html="$t('payments.payment')"></h4>
    </div>
    <hr>
    <b-row class="mb-3" v-if="showPriceBlock">
        <b-col cols="12" md="6">
            <div><span v-html="$t('payments.price')"></span>: <span :class="{'line-through': discountApplied}" v-html="`${price} ${currency}`"></span></div>
            <div v-if="discountApplied"><span v-html="$t('payments.discount')"></span>: <span v-html="`${discountApplied} ${discountSymbol}`"></span></div>
            <div v-if="discountApplied"><span v-html="$t('payments.priceWithDiscount')"></span>: <span v-html="finalPriceText"></span></div>
        </b-col>
        <b-col class="promotion-code-block" cols="12" md="6">
            <a v-if="showPromotionCodeQuestion" href="" @click.prevent="showPromotionCodeQuestion = false">{{ $t('payments.couponQuestion') }}</a>
            <div v-if="!showPromotionCodeQuestion"><base-input class="promotion-code-input" v-model="promotionCode" :placeholder="$t('payments.discountCoupon')"></base-input> <base-button @click="checkPromotionCode">{{$t('payments.verify')}}</base-button></div>
        </b-col>
    </b-row>
    <b-row v-if="!hidePaymentSelector && !freeService">
        <div>
            <h4 v-html="$t('payments.selectPaymentMethod')"></h4>
            <b-form-group>
                <b-form-radio v-model="paymentMethodSelected" name="payment-selector" :value="CREDIT_CARD_OPTION"><img src="/static-appopensalud/img/icons/creditcard-grey.svg" alt="" height="15" width="15" /> {{$t('payments.debitCreditCard')}}</b-form-radio>
                <b-form-radio v-model="paymentMethodSelected" name="payment-selector" :value="BIZUM_OPTION"><img src="/static-appopensalud/img/icons/bizum.png" alt="" height="15" width="15" /> {{$t('payments.bizum')}}</b-form-radio>
            </b-form-group>
        </div>
    </b-row>
    <form class="payment-block" v-show="showCreditCardForm && !freeService" id="paytpvPaymentForm">
        <b-row>
            <b-col cols="12">
                <span v-html="$t('payments.cardnumber')"></span>
                <base-input v-model="creditCardData.cardNumber"></base-input>
                <base-input v-show="false" v-model="creditCardData.sanitizedCardNumber" :dataAttributes="{'data-paytpv': 'paNumber'}"></base-input>
            </b-col>
            <b-col cols="12" md="3">
                <span v-html="$t('payments.expiration')"></span>
                <base-select v-model="creditCardData.month" :options="months" :placeholder="$t('month')" label="text"></base-select>
                <base-input v-show="false" v-model="creditCardData.month" :dataAttributes="{'data-paytpv': 'dateMonth'}"></base-input>
            </b-col>
            <b-col class="mb-4" cols="12" md="3" offset-md="1">
                <span class="hidden" v-html="$t('payments.year')"></span>
                <base-select v-model="creditCardData.year" :options="years" :placeholder="$t('year')" label="text"></base-select>
                <base-input v-show="false" v-model="creditCardData.year" :dataAttributes="{'data-paytpv': 'dateYear'}"></base-input>
            </b-col>
            <b-col cols="12" md="3" offset-md="2">
                <span v-html="$t('payments.cvv')"></span>
                <base-input :type="cvvInputType" v-model="creditCardData.cvv" @keyup="cvvChange" :maxlength="4" autocomplete="off" :dataAttributes="{'data-paytpv': 'cvc2'}"></base-input>
            </b-col>
            <b-col cols="12">
                <span v-html="$t('payments.holdername')"></span>
                <base-input v-model="creditCardData.holderName" :dataAttributes="{'data-paytpv': 'cardHolderName'}"></base-input>
            </b-col>
        </b-row>
    </form>
    <div class="payment-block" v-if="showBizumForm  && !freeService">
        <p v-html="showBizumDirect ? $t('payments.bizumDirectBanner') : $t('payments.bizumBanner')"></p>
    </div>
    <div v-if="showConfirmBlock">
        <b-row>
            <b-col cols="12">
                <base-checkbox v-model="termsAccepted">
                    <span v-html="$t('signupOH.accept-terms-patient')"></span>
                </base-checkbox>
            </b-col>
        </b-row>
        <hr>
        <b-row>
            <b-col class="text-center" cols="12">
                <small v-html="$t('payments.paymentAdvice1')"></small>
            </b-col>
            <b-col class="text-center mt-3" cols="12">
                <small class="block" v-html="$t('payments.fiscalData1')"></small>
                <small class="block" v-html="$t('payments.fiscalData2')"></small>
                <small class="block" v-html="$t('payments.fiscalData3')"></small>
                <small class="block" v-html="$t('payments.fiscalData4')"></small>
            </b-col>
        </b-row>
        <b-row class="mt-5">
            <b-col cols="12" class="text-center">
                <back-button withoutArrow :action="() => $emit('back')" class="mr-3"></back-button> <base-button @click="payAction">{{ payBtnTitle }}</base-button>
            </b-col>
        </b-row>
    </div>
    <base-dialog v-model="showEPrescriptionAvailableDialog" :okFn="() => { sendPaymentData() }" :okBtnText="$t('confirm')" :cancelBtnText="$t('cancel')" :cancelFn="() => {}" :content="$t('payments.ePrescriptionTax')"></base-dialog>
  </div>
</template>

<script>
import BaseButton from '../base/buttons/BaseButton'
import BackButton from '../base/buttons/BackButton'
import BaseDialog from '@/components/base/BaseDialog'
import { inProductionEnv } from '@/helpers/global.helpers'
import { APPOINTMENT_ERROR, PENDING_PAYMENT } from '@/constants/paymentTypes'
import paymentsRepository from '@/repositories/PaymentsRepository'
import { BFormGroup, BFormRadio } from 'bootstrap-vue'
import paymentsMixin from '@/mixins/payments.mixin'

const CREDIT_CARD_OPTION = 0
const BIZUM_OPTION = 1

export default {
    components: {
        BaseButton,
        BackButton,
        BFormGroup,
        BFormRadio,
        BaseDialog
    },
    props: {
        price: Number,
        paymentType: Number,
        appointmentId: Number,
        copayment: Boolean,
        ePrescriptionAvailable: Boolean,
        servicesPackageId: String,
        profIdForWrittenFlatRate: String,
        appointmentData: Object,
        paymentsTypes: Object
    },
    computed: {
        bizumDirectNotAllowed () {
            return this.copayment || this.ePrescriptionAvailable || this.servicesPackageId || this.profIdForWrittenFlatRate
        },
        showBizumDirect () {
            return this.bizumDirectNotAllowed ? false : !!this.paymentInfo.bizumPhone
        },
        hidePaymentSelector () {
            if (this.bizumPaymentNotAllowed) {
                return true
            } else if (this.bizumDirectNotAllowed) {
                return false
            } else {
                return (this.paymentInfo.bizumPaymentEnabled && !this.paymentInfo.creditCardPaymentEnabled) || this.ePrescriptionAvailable
            }
        },
        bizumPaymentNotAllowed () {
            return !!this.profIdForWrittenFlatRate
        },
        showCreditCardForm () {
            return this.paymentMethodSelected === CREDIT_CARD_OPTION || (this.hidePaymentSelector && !this.showBizumDirect)
        },
        showBizumForm () {
            return this.paymentMethodSelected === BIZUM_OPTION || (this.hidePaymentSelector && this.showBizumDirect)
        },
        showConfirmBlock () {
            return this.paymentMethodSelected !== null || this.hidePaymentSelector || this.freeService
        },
        payBtnTitle () {
            return this.paymentMethodSelected === CREDIT_CARD_OPTION ? this.$t('payments.confirmPayment') : this.freeService ? this.$t('continue') : this.$t('payments.authorizePayment')
        }
    },
    created () {
        if (this.paymentsTypes) {
             Object.assign(this.paymentInfo, this.paymentsTypes)
        } else if (this.paymentType === PENDING_PAYMENT || this.paymentType === APPOINTMENT_ERROR) {
            this.getPaymentInfo()
        }
    },
    mounted () {
        if (inProductionEnv) { import('../../../static-appopensalud/paytpvModalProduccion.js') } else { import('../../../static-appopensalud/paytpvModalPruebas.js') }
    },
    mixins: [paymentsMixin],
    data () {
      return {
        paymentMethodSelected: null,
        fullDiscount: false,
        cvvInputType: 'text',
        creditCardData: {
            holderName: null,
            cardNumber: null,
            sanitizedCardNumber: null,
            month: null,
            year: null,
            cvv: null
        },
        paymentInfo: {
            bizumPaymentEnabled: null,
            creditCardPaymentEnabled: null,
            bizumPhone: null
        },
        paytpvToken: null,
        CREDIT_CARD_OPTION,
        BIZUM_OPTION
      }
    },
    methods: {
        getPaymentInfo () {
            paymentsRepository.getPaymentInfo(this.appointmentId).then((result) => {
                if (result.data.data) {
                    this.paymentInfo = result.data.data
                    this.paymentMethodSelected = null
                } else {
                    this.$store.dispatch('showDangerAlert', this.$t('defaultErrorMessage'))
                }
            })
        },
        payAction () {
            this.paytpvToken = null
            if (!this.termsAccepted) {
                this.$store.dispatch('showInfoAlert', this.$t('payments.acceptTerms'))
            } else if (this.freeService) {
                this.applyFullDiscount()
            } else if (this.showCreditCardForm) {
                this.pay()
            } else {
                this.payBizum()
            }
        },
        payBizum () {
            if (this.appointmentData && this.showBizumDirect) {
                this.onFreeAppointmentOrBizumDirect()
            } else if (this.showBizumDirect) {
                this.updateBizumDirectStatus()
            } else {
                this.checkEPrescription()
            }
        },
        updateBizumDirectStatus () {
            paymentsRepository.updateBizumDirectStatus({appointmentId: this.appointmentId, promotionCode: this.promotionCode}).then((result) => {
                if (result.data.data) {
                    this.$store.dispatch('payments/showBizumDirectConfirmDialog', { phone: this.paymentInfo.bizumPhone, okFn: () => { this.closeModalAndReload() } })
                } else {
                    this.$store.dispatch('showDangerAlert', this.$t('defaultErrorMessage'))
                }
            })
        },
        pay () {
            if (!this.creditCardData.holderName) {
                this.$store.dispatch('showInfoAlert', this.$t('payments.enterHolderName'))
            } else if (!this.creditCardData.cardNumber) {
                this.$store.dispatch('showInfoAlert', this.$t('payments.enterCardNumber'))
            } else if (!this.creditCardData.month) {
                this.$store.dispatch('showInfoAlert', this.$t('payments.selectMonth'))
            } else if (!this.creditCardData.year) {
                this.$store.dispatch('showInfoAlert', this.$t('payments.selectYear'))
            } else if (!this.creditCardData.cvv) {
                this.$store.dispatch('showInfoAlert', this.$t('payments.enterCvv'))
            } else {
                new PAYTPV.Tokenizator().getToken(document.forms['paytpvPaymentForm'], (data) => {
                    if (data.errorID !== 0 || data.paytpvToken === '') {
                        this.$store.dispatch('showDangerAlert', data.errorText.replace('Ãº', 'ú'))
                        return
                    }
                    this.paytpvToken = data.paytpvToken
                    this.checkEPrescription()
                })
            }
        },
        checkEPrescription () {
            if (this.ePrescriptionAvailable) {
                this.showEPrescriptionAvailableDialog = true
            } else {
                this.sendPaymentData()
            }
        },
        getPaymentData () {
            let data = {
                servicesPackageId: this.servicesPackageId,
                profId: this.profIdForWrittenFlatRate,
                paytpvToken: this.paytpvToken || null,
                promotionCode: this.promotionCode,
                appointmentId: this.appointmentId,
                paymentType: this.paymentType,
                bizumPayment: this.paymentMethodSelected === BIZUM_OPTION && !this.showBizumDirect
            }
            if (this.appointmentData) {
                data = { ...this.appointmentData, ...data }
            }
            return data
        },
        sendPaymentData () {
            paymentsRepository.sendPaytpvPayment(this.getPaymentData()).then((result) => {
                if (!result.data) {
                    this.$store.dispatch('showDangerAlert', this.$t('defaultErrorMessage'))
                } else {
                    location.href = result.data.data
                }
            })
        }
    }
}
</script>

<style scoped lang="scss">
@import '../../../static-appopensalud/css/webapp/payments.scss';
</style>


// WEBPACK FOOTER //
// src/components/payment/PaycometPayment.vue